import { createBrowserHistory } from "history";

// Shared with Routes.jsx's <Router> so code outside React components (like the
// axios 401 interceptor in services/apiClient.js) can redirect to /login too.
const history = createBrowserHistory();

export default history;
